<template>
  <div class="view-insurance-plan">
     <div class="header">
      <div class="back-btn" @click="goBack"><img src="@/assets/images/icon-back.png"></div>
      <div class="title">保障计划详情</div>
    </div>
    <!-- <h3 class="header">保障计划详情</h3> -->
    <div class="plan-item" id="insPlanItem">
      <dl :class="{'clearfix':clearfix}" v-for="(item, index) in insuranceArr" :key="index">
        <dt>{{item.title}}</dt>
        <dd>{{item.value}}</dd>
      </dl>
      
      <!-- <dl class="clearfix">
        <dt>一般医疗保险金</dt>
        <dd>200万元</dd>
      </dl>
      <dl class="clearfix">
        <dt>特定疾病医疗保险金</dt>
        <dd>200万元</dd>
      </dl>
      <dl class="clearfix">
        <dt>年免赔额</dt>
        <dd>2万元</dd>
      </dl>
      <dl class="clearfix">
        <dt>就医绿色通道</dt>
        <dd>1次</dd>
      </dl>
      <dl class="clearfix">
        <dt>恶性肿瘤二诊</dt>
        <dd>1次</dd>
      </dl>
    </div>
    <div class="gray-line"></div>
    <div class="plan-item">
      <dl class="clearfix">
        <dt>家庭护理(慢病版）</dt>
        <dd>打针、普通换药、外科拆线、雾化、吸痰各一次</dd>
      </dl>
      <dl class="clearfix">
        <dt>私人健康顾问(慢病版）</dt>
        <dd>体检报告报告解读、运动/饮食/用药指导、视频医生问诊、送药上门(药费自理)，不限次</dd>
      </dl>
      <dl class="clearfix">
        <dt>保障区域</dt>
        <dd>中国大陆(不含港澳台)</dd>
      </dl>
      <dl class="clearfix">
        <dt>医院范围</dt>
        <dd>二级以上(含二级)公立医院普通部</dd>
      </dl>
      <dl class="clearfix">
        <dt>保障年龄</dt>
        <dd>18-55周岁</dd>
      </dl>
      <dl class="clearfix">
        <dt>保障期限</dt>
        <dd>1年</dd>
      </dl>
      <dl class="clearfix">
        <dt>缴费方式</dt>
        <dd>年缴/月缴</dd>
      </dl> -->
    </div>
  </div>
</template>

<script>

// @ is an alias to /src
// 根api地址，通过环境变量的配置获取
const API_PATH = process.env.VUE_APP_API_URL;
// 业务api地址
const API_WEB_ARRANGES = `${API_PATH}/mapi/insurance/insuranceBase/baseAPI/insuranceWebArranges.json`;
import base from '../mixins/base';
export default {
  name: 'insurancePlan',
  mixins: [base],
  data() {
    return {
      name: '保障计划详情',
      insuranceId: '',
      pageId: '',
      clearfix:true,
      insuranceArr:[]
    }
  },
  components:{

  },
  computed: {
    
  },
  methods: {
    goBack() {
      if (this.$store.state.preRoute) {
        this.$router.go(-1);
      } else {
        window.history.go(-1);
      } 
    },
    async getResult() {
      this.showLoading();
      let params = {'insuranceId': this.insuranceId, 'pageId': this.pageId};
      const response = await axios.post(API_WEB_ARRANGES, params);
      console.log("response===",response);
      this.hideLoading();
      if (response.code === 1) {
          this.insuranceArr = response.data.insuranceArranges;
      }
    }
  },
   mounted() {
    let self = this;
    let origin = window.location.origin;
    let shareConfig = {
      //分享标题
      title:"i康保·百万医疗（慢病版）",
      //分享图片地址
      imgUrl:origin+'/share/statics/images/product/101.png',
      //分享链接地址
      linkUrl:this.$cookie.get('p-share-link'),
      //分享描述文案
      description:"最高报销400万各类医疗费 指定慢病既往症也能保 保费最高优惠30%"
    }
    PinganHealth.wxShare(shareConfig);
  },
  created() {
    var self=this;
    let query = this.$route.query;
    self.insuranceId = query.insid;
    self.pageId = query.pid
    self.getResult();
  }
}
</script>

<style scoped lang="stylus">
  .header
    width: 100%
    height: 1rem
    line-height: 1rem
    background-color: #fff
    color: #333
    text-align: center
    font-size: .34rem
    position: absolute
    top: 0
    left: 0
    display: flex
    z-index: 99
    border-bottom: 1px solid #f5f5f5
    .back-btn
      position: absolute
      top: .3rem
      left: .3rem
      width: .38rem
      height: .38rem
      img
        display: block
        width: 100%
        height: 100%  
    .title
      width: 100%
      text-align: center
  .view-insurance-plan
    color:#333
    font-size:.28rem
    font-weight:400
    margin-bottom:.68rem
    .plan-item 
      padding-top: 1rem;
      .spb
        border-bottom: .2rem solid #F5F5F5;
      .clearfix
        &:after
          content: ''
          display: block
          overflow: hidden
          visibility: hidden
          clear: both
      dl
        padding:0.22rem 0.28rem 0.24rem 0.3rem
        border-top: 1px solid #f7f7f7
        dt
          float: left
          width: 42%
        dd
          float: right
          width: 58%
          text-align: right
          color: #666
    .gray-line 
        height: .2rem
        background: #F5F5F5
      
</style>
